import _ from 'lodash';

import type { Submission } from 'bundles/assess-common/types/NaptimeSubmission';
import type { SubmissionSchema } from 'bundles/assess-common/types/NaptimeSubmissionSchema';
import { getBlankSubmissionPart } from 'bundles/assess-common/utils/defaultSubmissionParts';

const initializeSubmissionFromSchema = (
  submissionSchema: SubmissionSchema,
  userId: number,
  defaultText?: string
): Submission => {
  const parts = _.fromPairs(
    _.map(submissionSchema.parts, ({ id, details }) => {
      return [id, getBlankSubmissionPart(details.typeName, defaultText)];
    })
  );

  return {
    title: '',
    parts,
    invalidParts: {},
    // The following properties are not defined on Submission
    // @ts-expect-error TSMIGRATION
    isDraft: true,
    submittedBy: userId,
    submittedAt: Date.now(),
    id: '',
  };
};

export default initializeSubmissionFromSchema;
